module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product19-e0bc4a104fe8570f451a0ab016fc9da9.jpg";